// extracted by mini-css-extract-plugin
export default {"logo-ecf":"logo-ecf","logo-frn":"logo-frn","logo-footer":"logo-footer","nav-footer":"nav-footer","list-inline-item":"list-inline-item"};